module.exports = __webpack_public_path__ + "static/bx-23-7e662cb67c4616da3e01ee2680ca6cd1.jpg";